export default __webpack_public_path__ + "static/media/gbm.ed23c963.svg";